// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"00e46234cc60935d398e","293":"97d871ff60af1095f066","452":"90271e6555f3d6114b40","896":"fc7210e161579b54fa1c"}[chunkId] + ".js";
};